import React, { useRef } from 'react';
import { Box, debounce } from '@mui/material';
import clsx from 'clsx';
import { spinningClasses } from './style';
import VisibleAreaProbe from '../../Shared/VisibleAreaProbe';
function shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const SpinningBase = (props) => {
    const { sx, className, spinning: customSpinning = true, label, delay, viewportClipping, children, } = props;
    const [spinning, setSpinning] = React.useState(() => customSpinning && !shouldDelay(customSpinning, delay));
    const spinRef = useRef(null);
    React.useEffect(() => {
        if (!customSpinning) {
            setSpinning(false);
            return undefined;
        }
        const showSpinning = debounce(() => {
            setSpinning(true);
        }, delay);
        showSpinning();
        return () => {
            showSpinning.clear();
        };
    }, [customSpinning, delay]);
    const indicator = (React.createElement("div", { className: clsx(spinningClasses.spikes, spinningClasses.spikesSpin) },
        React.createElement("div", { className: spinningClasses.spikesItem, key: 1 }),
        React.createElement("div", { className: spinningClasses.spikesItem, key: 2 }),
        React.createElement("div", { className: spinningClasses.spikesItem, key: 3 }),
        React.createElement("div", { className: spinningClasses.spikesItem, key: 4 }),
        React.createElement("div", { className: spinningClasses.spikesItem, key: 5 }),
        React.createElement("div", { className: spinningClasses.spikesItem, key: 6 }),
        React.createElement("div", { className: spinningClasses.spikesItem, key: 7 }),
        React.createElement("div", { className: spinningClasses.spikesItem, key: 8 })));
    const spinElement = (React.createElement(Box, { sx: sx, className: clsx(className, spinningClasses.spinWrapper, {
            [`${spinningClasses.spinWrapperClipping}`]: viewportClipping,
        }), ref: spinRef, "aria-live": "polite", "aria-busy": spinning },
        indicator,
        label ? React.createElement("div", { className: spinningClasses.text }, label) : null));
    if (!children && spinning) {
        return spinElement;
    }
    function handleVisibleAreaChange(area) {
        const spinDOM = spinRef.current;
        // istanbul ignore next
        if (!spinDOM) {
            return;
        }
        const { style, classList, parentElement } = spinDOM;
        if (area.visible) {
            classList.add(spinningClasses.spinWrapperClipped);
            const spinWidth = spinDOM.clientWidth;
            const spinHeight = spinDOM.clientHeight;
            const parentWidth = parentElement.clientWidth;
            const parentHeight = parentElement.clientHeight;
            let left = area.left + area.width / 2;
            let top = area.top + area.height / 2;
            if (parentWidth > spinWidth && area.width < spinWidth) {
                if (area.left < 1) {
                    left = spinWidth / 2;
                }
                if (area.left + area.width > parentWidth - 1) {
                    left = parentWidth - spinWidth / 2;
                }
            }
            if (parentHeight > spinHeight && area.height < spinHeight) {
                if (area.top < 1) {
                    top = spinHeight / 2;
                }
                if (area.top + area.height > parentHeight - 1) {
                    top = parentHeight - spinHeight / 2;
                }
            }
            style.left = `${left}px`;
            style.top = `${top}px`;
        }
        else {
            classList.remove(spinningClasses.spinWrapperClipped);
            style.top = '';
            style.left = '';
        }
    }
    return (React.createElement(Box, { className: clsx(spinningClasses.nestedWrapper, className), sx: {
            position: 'relative',
            ...sx,
        } },
        spinning && spinElement,
        spinning && viewportClipping && (React.createElement(VisibleAreaProbe, { onVisibleAreaChange: handleVisibleAreaChange })),
        React.createElement("div", { className: clsx(spinningClasses.nestedContentWrapper, {
                [`${spinningClasses.nestedContentWrapper}-blur`]: spinning,
            }) }, children)));
};
export { SpinningBase };
